import '@/plugins/jquery';
import App from '@/app.vue';
import '@/assets/scss/main.scss';
import sharedComponents from '@/components/shared';
import '@/helpers/api';
import '@/helpers/directives';
import '@/helpers/filters';
import '@/helpers/mixins';
import '@/local/index';
import '@/plugins/fragment';
import '@/plugins/reactive-provide';
import '@/plugins/vee-validate';
import '@/plugins/vue-the-mask';
import vuetify from '@/plugins/vuetify';
import router from '@/routes';
import store from '@/store/index';
import 'babel-polyfill'; // babel polyfill for IE11 and Safari 9
import Vue from 'vue';

// @TODO: These should be removed.
import '@/plugins/iview';

Vue.config.productionTip = false;

for (const key in sharedComponents) {
  if (Object.prototype.hasOwnProperty.call(sharedComponents, key)) {
    Vue.component(sharedComponents[key].name, sharedComponents[key]);
  }
}

export default new Vue({
  router,
  store,
  render: h => h(App),
  vuetify,
}).$mount('#app');
